import { render, staticRenderFns } from "./EnglishResumeAddressCard.vue?vue&type=template&id=ce66f8d0"
import script from "./EnglishResumeAddressCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumeAddressCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports